export function shouldUseContentReviewImportCapability(srcFormat) {
	return srcFormat === "docx";
}

export function buildContentReviewV2ImportRequest(importFilePath, srcFormat) {
	return {
		importFilePath,
		srcFormat
	};
}

export function buildAuthorizedContentReviewV2LambdaEvent(authorization = {}) {
	return {
		importFilePath: authorization.importFilePath,
		srcFormat: authorization.srcFormat,
		contentReviewImportCapability: authorization.contentReviewImportCapability
	};
}

export function isValidContentReviewV2ImportAuthorization(authorization = {}) {
	return (
		authorization.success === true
		&& typeof authorization.importFilePath === "string"
		&& authorization.importFilePath !== ""
		&& authorization.srcFormat === "docx"
		&& authorization.contentReviewImportCapability
		&& typeof authorization.contentReviewImportCapability === "object"
	);
}
